import angular from 'angular';
import '../resources/connect-wizard';

const module = angular.module('whyline.services.connect-wizard', [
  'whyline.resources.connect-wizard',
]);

let ConnectWizard;

class ConnectWizardService {

  static $inject = ['ConnectWizard'];

  constructor(injectedConnectWizard) {
    ConnectWizard = injectedConnectWizard;
  }

  IsConnectAlreadySetUp() {
    return ConnectWizard.IsConnectAlreadySetUp();
  }

  GetAsPromise() {
    return ConnectWizard.GetAsPromise();
  }

  CreateInstance() {
    return new ConnectWizard();
  }

  SaveConnectData(data) {
    return ConnectWizard.SaveConnectData(data);
  }

  UpdateConnectData(data) {
    return ConnectWizard.UpdateConnectData(data);
  }
}

module.exports = module.service('ConnectWizardService', ConnectWizardService);
